// Will & Legacy Planning Webinar (legacy.affinitygroup.sg)
import en from "./en";
import zh from "./zh";

// Every session is shown to every visitor regardless of the page language.
// `language` / `langCode` drive the confirmation email, calendar invite and Zoom
// registration; `label`/`short` carry both display-language renderings.
//
// The first English session auto-rolls: once the 5 Sep 2026 session has ended
// (1h after its 10:00 SGT start), it is replaced by the next date, 9 Jan 2027.
const EN_SEP_5 = {
  iso: "2026-09-05T10:00:00+08:00",
  language: "English",
  langCode: "en",
  speakerId: "nicholas",
  speaker: "Nicholas Lee",
  label: { en: "Saturday, 5 September 2026", zh: "2026年9月5日（星期六）" },
  short: { en: "5 Sep 2026", zh: "9月5日" },
};
const EN_JAN_9 = {
  iso: "2027-01-09T10:00:00+08:00",
  language: "English",
  langCode: "en",
  speakerId: "nicholas",
  speaker: "Nicholas Lee",
  label: { en: "Saturday, 9 January 2027", zh: "2027年1月9日（星期六）" },
  short: { en: "9 Jan 2027", zh: "1月9日" },
};
const EN_NOV_7 = {
  iso: "2026-11-07T10:00:00+08:00",
  language: "English",
  langCode: "en",
  speakerId: "nicholas",
  speaker: "Nicholas Lee",
  label: { en: "Saturday, 7 November 2026", zh: "2026年11月7日（星期六）" },
  short: { en: "7 Nov 2026", zh: "11月7日" },
};

const SEP_5_ENDED = Date.now() > new Date("2026-09-05T11:00:00+08:00").getTime();
const englishSessions = [SEP_5_ENDED ? EN_JAN_9 : EN_SEP_5, EN_NOV_7].sort(
  (a, b) => new Date(a.iso) - new Date(b.iso),
);

const legacy = {
  id: "legacy",
  theme: "legacy",
  storagePrefix: "affinityLegacy",
  siteName: "Affinity Legacy Webinar",
  webinar: { en: "Will & Legacy Planning webinar", zh: "《遗嘱与财富传承规划》线上讲座" },
  topic: { en: "legacy planning", zh: "传承规划" },
  admin: { kicker: "Legacy dashboard", subtitle: "Will & Legacy Planning · Registrations", tag: "Legacy" },
  pixelContentName: "Legacy Webinar Registration",
  guide: true,
  dictionaries: { en, zh },
  sessions: [
    ...englishSessions,
    {
      iso: "2026-09-19T10:00:00+08:00",
      language: "Chinese",
      langCode: "zh",
      speakerId: "vincent",
      speaker: "Vincent Chua 蔡镇安",
      label: { en: "Saturday, 19 September 2026", zh: "2026年9月19日（星期六）" },
      short: { en: "19 Sep 2026", zh: "9月19日" },
    },
    {
      iso: "2026-11-21T10:00:00+08:00",
      language: "Chinese",
      langCode: "zh",
      speakerId: "fion",
      speaker: "Fion Yong 杨炎芬",
      label: { en: "Saturday, 21 November 2026", zh: "2026年11月21日（星期六）" },
      short: { en: "21 Nov 2026", zh: "11月21日" },
    },
  ],
  // Event highlight & testimonial clips from past physical seminars (9:16 portrait), per page language.
  videos: {
    en: [
      { id: "1223910834", hash: "bacc43171d", speaker: "Nicholas Lee", caption: "Physical seminar · April 2025", title: "Will & Legacy Planning Seminar highlights (April 2025)" },
      { id: "1223910936", hash: "e067cacf8c", speaker: "Nicholas Lee", caption: "Physical seminar · November 2025", title: "Will & Legacy Planning Seminar highlights (November 2025)" },
    ],
    zh: [
      { id: "1223913486", hash: "4b4c1f3be2", speaker: "Vincent Chua 蔡镇安", caption: "实体讲座 · 2025年7月", title: "遗嘱与财富传承实体讲座精彩回顾（2025年7月）" },
    ],
  },
  questionIds: ["will", "cpf", "roles", "assets", "review", "unsure", "other"],
};

export default legacy;
